import React, {useEffect, useState} from "react";
import {changePageSizeState} from "../../../Slices/PageSlice";
import PageSizeState from "../../../Constants/Base/PageSizeState";
import {useDispatch} from "react-redux";
import TablePage from "../../../Components/DataGrid/TablePage";
import strings from "../../../localization";
import {changeBreadcrumbs} from "../../../Slices/BreadcrumbsSlice";
import TablePageContext, {
    FilterDefaults,
    TableDataDefaults,
    TablePageOptionDefaults
} from "../../../Context/TablePageContext";
import PageState from "../../../Constants/Base/PageState";
import {
    deleteCompanyDocumentTemplateItem,
    getCompanyDocumentTemplateItems
} from "../../../Services/CompanyDocumentManagement/CompanyDocumentTemplateItemService";
import AddCompanyDocumentTemplateItem from "./AddCompanyDocumentTemplateItem";
import {getCompanyDocumentItemTypeString} from "../../../Constants/CompanyDocumentManagement/CompanyDocumentItem/CompanyDocumentItemType";
import EditCompanyDocumentTemplateItem from "./EditCompanyDocumentTemplateItem";
import {
    getCompanyDocumentReferenceTypeString
} from "../../../Constants/CompanyDocumentManagement/CompanyDocumentItem/CompanyDocumentReferenceType";
import {getCompanyDocumentReferenceUserValueTypeString} from "../../../Constants/CompanyDocumentManagement/CompanyDocumentItem/CompanyDocumentReferenceValueTypes/CompanyDocumentReferenceUserValueType";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ReferenceType from "../../../Constants/DocumentManagement/ReferenceType";
import AppPermissions from "../../../Constants/Permissions/Permissions";
import Modules from "../../../Constants/Base/Modules";
import Tag from "../../../Components/Forms/Pages/Document/Tag/Tag";

const tableDescription = [
    { field: 'name', headerName: strings.pages.companyDocument.companyDocumentTemplateItem.companyDocumentTemplateItemList.name, width: 250},
    { field: 'code', headerName: strings.pages.companyDocument.companyDocumentTemplateItem.companyDocumentTemplateItemList.code, width: 250 },
    { field: 'type', headerName: strings.pages.companyDocument.companyDocumentTemplateItem.companyDocumentTemplateItemList.type, valueFormatter: params => getCompanyDocumentItemTypeString(params.value), width: 250 },
    { field: 'referenceType', headerName: strings.pages.companyDocument.companyDocumentTemplateItem.companyDocumentTemplateItemList.referenceType, valueFormatter: params => getCompanyDocumentReferenceTypeString(params.value), width: 250 },
    { field: 'referenceValueType', headerName: strings.pages.companyDocument.companyDocumentTemplateItem.companyDocumentTemplateItemList.referenceValueType, valueFormatter: params => getCompanyDocumentReferenceUserValueTypeString(params.value), width: 250},
];

const filters = []

const CompanyDocumentTemplateItemList = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {id: companyDocumentTemplateId} = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [updatedFilter, setUpdatedFilter] = useState(!Boolean(searchParams.toString()));
    const [columns, setColumns] = useState([]);
    const [pageState, setPageState] = useState(PageState.View);
    const [filter, setFilter] = useState(FilterDefaults);
    const [tableData, setTableData] = useState(TableDataDefaults);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);
    const [selectedItems, setSelectedItems] = useState(null);
    const [tablePageOptions, setTablePageOptions] = useState(TablePageOptionDefaults);
    const referenceType = ReferenceType.COMPANY_DOCUMENT_TEMPLATE_ITEM;
    const permissionGroup = AppPermissions.COMPANY_DOCUMENT_TEMPLATE_ITEM.GROUP;

    const value = {
        tablePageOptions, setTablePageOptions,
        selectionModel, setSelectionModel,
        selectedItems, setSelectedItems,
        filter, setFilter, pageState, setPageState, showDeleteDialog, setShowDeleteDialog,
        navigate, updatedFilter, setUpdatedFilter
    }

    useEffect(() => {
        setColumns([...tableDescription]);
        dispatch(changePageSizeState(PageSizeState.SHORT));
        dispatch(changeBreadcrumbs({
            title: strings.pages.companyDocument.companyDocumentTemplateItem.companyDocumentTemplateItemList.pageTitle,
            hierarchy:[
                {label: strings.navigation.managmentTag},
                {label: Modules.DOCUMENTS},
                {label: strings.pages.companyDocument.companyDocumentTemplate.companyDocumentTemplateList.pageTitle},
                {label: strings.pages.companyDocument.companyDocumentTemplateItem.companyDocumentTemplateItemList.pageTitle},
            ],        
        }));

        return () => {
            setTableData({})
        }
    }, [])

    useEffect(() => {
        if(!updatedFilter){
            return;
        }

        fetch();
    }, [filter, updatedFilter]);

    const onCancel = () => {
        setPageState(PageState.View);
    }

    const onFinish = () => {
        fetch();
        setPageState(PageState.View);
    }

    const fetch = () => {
        setTableData({
            ...tableData,
            loading: true
        });

        getCompanyDocumentTemplateItems({
            companyDocumentTemplateId,
            ...filter
        }).then(response => {

            if (!response || !response.ok) {
                return;
            }

            setTableData({
                loading: false,
                data: response.data.result,
                total: response.data.total
            });
        })
    }

    return <TablePageContext.Provider value={value}>
        <TablePage onFinish={() => onFinish()} deleteItem={deleteCompanyDocumentTemplateItem} tableDescription={columns}
                   tableData={tableData} filter={filter} filters={filters}
                   permissionGroup={permissionGroup}
                   referenceType={referenceType}
                   tagPage={<Tag referenceType={ referenceType } data={ selectedItems } /> }
                   editPage={<EditCompanyDocumentTemplateItem data={ selectedItems }
                                          onCancel={() => onCancel()} onFinish={() => onFinish()}/>}
                   addPage={<AddCompanyDocumentTemplateItem companyDocumentTemplateId = {companyDocumentTemplateId} onCancel={() => onCancel()} onFinish={() => onFinish()}/>}
                   addButtonText={strings.components.tablePage.addButton.companyDocumentTemplateItem}
        />
    </TablePageContext.Provider>;
}

export default CompanyDocumentTemplateItemList;
